/** @module global/useHours */
import { useContext, useEffect, useState, useCallback } from 'react';
import { AuthContext } from '../components/authentication/AuthContext';
import SimpleCache from './Cache';
import { getHours } from './request/restaurant';

const cache = new SimpleCache();

function useHours(restaurantId) {
  const authCtx = useContext(AuthContext);
  const [hours, setHours] = useState([]);

  const cacheKey = `${restaurantId} hours`;

  const reload = useCallback(async () => {
    if (!authCtx.tokens || !restaurantId) return;

    const response = await getHours(restaurantId, authCtx.tokens.idToken);
    setHours(response);

    cache.store(cacheKey, response);
  }, [authCtx.tokens, restaurantId, cacheKey]);

  useEffect(() => {
    if (!cache.has(cacheKey)) {
      reload();
    } else {
      setHours(cache.retrieve(cacheKey));
    }
  }, [reload, restaurantId, cacheKey]);

  return [reload, hours];
}

export default useHours;
